import { Tokens } from '@chakra-ui/react';
import { compose, system } from '../system';

type SpaceKeys = Tokens['spacing'];

export type ThemeSpace = SpaceKeys | `${SpaceKeys}` | 'auto';

const marginConfig: Record<string, any> = {
  margin: {
    property: 'margin',
    scale: 'spacing',
  },
  marginTop: {
    property: 'marginTop',
    scale: 'spacing',
  },
  marginRight: {
    property: 'marginRight',
    scale: 'spacing',
  },
  marginBottom: {
    property: 'marginBottom',
    scale: 'spacing',
  },
  marginLeft: {
    property: 'marginLeft',
    scale: 'spacing',
  },
  marginX: {
    properties: ['marginLeft', 'marginRight'],
    scale: 'spacing',
  },
  marginY: {
    properties: ['marginTop', 'marginBottom'],
    scale: 'spacing',
  },
};

marginConfig.m = marginConfig.margin;
marginConfig.mt = marginConfig.marginTop;
marginConfig.mr = marginConfig.marginRight;
marginConfig.mb = marginConfig.marginBottom;
marginConfig.ml = marginConfig.marginLeft;
marginConfig.mx = marginConfig.marginX;
marginConfig.my = marginConfig.marginY;

const paddingConfig: Record<string, any> = {
  padding: {
    property: 'padding',
    scale: 'spacing',
  },
  paddingTop: {
    property: 'paddingTop',
    scale: 'spacing',
  },
  paddingRight: {
    property: 'paddingRight',
    scale: 'spacing',
  },
  paddingBottom: {
    property: 'paddingBottom',
    scale: 'spacing',
  },
  paddingLeft: {
    property: 'paddingLeft',
    scale: 'spacing',
  },
  paddingX: {
    properties: ['paddingLeft', 'paddingRight'],
    scale: 'spacing',
  },
  paddingY: {
    properties: ['paddingTop', 'paddingBottom'],
    scale: 'spacing',
  },
};

paddingConfig.p = paddingConfig.padding;
paddingConfig.pt = paddingConfig.paddingTop;
paddingConfig.pr = paddingConfig.paddingRight;
paddingConfig.pb = paddingConfig.paddingBottom;
paddingConfig.pl = paddingConfig.paddingLeft;
paddingConfig.px = paddingConfig.paddingX;
paddingConfig.py = paddingConfig.paddingY;

const margin = system(marginConfig);
const padding = system(paddingConfig);

export type MarginProps = {
  margin?: ThemeSpace;
  marginTop?: ThemeSpace;
  marginRight?: ThemeSpace;
  marginBottom?: ThemeSpace;
  marginLeft?: ThemeSpace;
  marginX?: ThemeSpace;
  marginY?: ThemeSpace;
  m?: ThemeSpace;
  mt?: ThemeSpace;
  mr?: ThemeSpace;
  mb?: ThemeSpace;
  ml?: ThemeSpace;
  mx?: ThemeSpace;
  my?: ThemeSpace;
};

export type PaddingProps = {
  padding?: ThemeSpace;
  paddingTop?: ThemeSpace;
  paddingRight?: ThemeSpace;
  paddingBottom?: ThemeSpace;
  paddingLeft?: ThemeSpace;
  paddingX?: ThemeSpace;
  paddingY?: ThemeSpace;
  p?: ThemeSpace;
  pt?: ThemeSpace;
  pr?: ThemeSpace;
  pb?: ThemeSpace;
  pl?: ThemeSpace;
  px?: ThemeSpace;
  py?: ThemeSpace;
};

export type Space = MarginProps & PaddingProps;

export const space = compose(margin, padding);
